import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import * as Types from '../../store/types';
import * as actions from '../../store/constants/all';
// pages
import WelcomePage from './welcome-page';
import AppRoutes from './app-routes';
import AppFactory from '../../services/app-factory';
import { Log, Level } from 'ng2-logger';
import * as GT from '../../tools/general-tools';
import SSEProvider from '../../components/hooks/SSEContext';

declare var appSettings: Types.IAppSettings;

const L = Log.create('App');
const AF = AppFactory.create();

// set log level to production mode as default
if (process.env.NODE_ENV === 'production') {
  if (GT.getQueryStringParameter('loglevels') && GT.getQueryStringParameter('logleves') !== '*') {
    const logLevels = GT.getQueryStringParameter('loglevels').split(',').map((l: any) => parseInt(l, 10) as Level);
    Log.onlyLevel(...logLevels);
  } else if (!GT.getQueryStringParameter('loglevels')) {
    Log.setProductionMode();
  }
}

export default class App extends React.Component<Types.IAppProps, Types.IAppModuleState> {
  state: Types.IAppModuleState = {
    ready: false
  };

  componentDidMount() {
    AF.on(actions.gen.CORE_APP_READY, () => {
      if (!this.state.ready) {
        this.state.ready = true;
        this.forceUpdate();
      }
    });
  }

  componentDidUpdate() {
  }

  componentWillReceiveProps() {
  }

  componentWillUpdate() {
  }

  render() {
    document.title = appSettings.INSTITUTION_NAME + " " + appSettings.TITLE;

    let selector: any = 'description';
    document.getElementsByTagName('meta')[selector].content = appSettings.META_DESCRIPTION;

    selector = 'keywords';
    document.getElementsByTagName('meta')[selector].content = appSettings.INSTITUTION_NAME + ", " + appSettings.META_KEYWORDS;

    let content = null;
    if (this.state.ready) {
      content = <AppRoutes />;
    } else {
      content = <WelcomePage />;
    }

    return <SSEProvider>
      {content}
    </SSEProvider>
  }
}

/*
const mapStateToProps = (state: Types.IPersistedState, ownProps: Types.IAppProps): Types.IAppProps => {
  if (!state || !state.store) {
    return ownProps;
  }
  const newProps: Types.IAppProps = Object.assign({}, ownProps, {
    status: state.store.status
  });

  return newProps;
};

const dispatchProps = (dispatch: any) => ({
  dispatch
});

const app = connect(
  mapStateToProps,
  dispatchProps
)(App);

export default app;
*/
